import { Injectable, Inject } from '@angular/core';
import { Http, URLSearchParams, Headers, RequestOptions } from '@angular/http';
import { APP_BASE_HREF } from '@angular/common';
import { ORIGIN_URL } from './constants/baseurl.constants';
import { Product } from '../models/Product';
import { Version } from '../models/Version';
import { TransferHttp } from '../../modules/transfer-http/transfer-http';
import { Observable } from 'rxjs/Observable';
import { AuthHttp } from 'angular2-jwt';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class SoftwareService {
    constructor(
        private transferHttp: TransferHttp, // Use only for GETS that you want re-used between Server render -> Client render
        private http: Http, // Use for everything else
        private authHttp: AuthHttp,
        @Inject(ORIGIN_URL) private baseUrl: string) {

    }

    saveProduct(product: Product): Observable<any> {
        var resp = this.authHttp.put(`${this.baseUrl}/api/products/${product.Id}`, product);
        return resp;
    }
    
    getProducts(): Observable<any> {
        var resp = this.authHttp.get(`${this.baseUrl}/api/products`);
        return resp;
    }

    getProduct(updateId: string): Observable<any> {
        var resp = this.authHttp.get(`${this.baseUrl}/api/product/?updateid=${encodeURIComponent(updateId)}`);
        return resp;
    }

    getProductById(id: number): Observable<any> {
        var resp = this.authHttp.get(`${this.baseUrl}/api/products/${id}`);
        return resp;
    }

    getVersions(updateId: string): Observable<any> {
        var resp = this.authHttp.get(`${this.baseUrl}/api/product/${encodeURIComponent(updateId)}/versions`);
        return resp;
    }

    getLatestAlpha(updateId: string): Observable<any> {
        var resp = this.authHttp.get(`${this.baseUrl}/api/product/${encodeURIComponent(updateId)}/latestalpha`);
        return resp;
    }

    getLatestBeta(updateId: string): Observable<any> {
        var resp = this.authHttp.get(`${this.baseUrl}/api/product/${encodeURIComponent(updateId)}/latestbeta`);
        return resp;
    }

    getLatestProto(updateId: string): Observable<any> {
        var resp = this.authHttp.get(`${this.baseUrl}/api/product/${encodeURIComponent(updateId)}/latestproto`);
        return resp;
    }

    getLatestVersion(updateId: string): Observable<any> {
        var resp = this.authHttp.get(`${this.baseUrl}/api/product/${encodeURIComponent(updateId)}/latest`);
        return resp;
    }

    getVersionById(id: number): Observable<any> {
        var resp = this.authHttp.get(`${this.baseUrl}/api/version/${id}`);
        return resp;
    }

    getAllVersions(): Observable<any> {
        var resp = this.authHttp.get(`${this.baseUrl}/api/version/`);
        return resp;
    }

    saveVersion(version: Version): Observable<any> {
        var resp = this.authHttp.put(`${this.baseUrl}/api/version/${version.Id}`, version);
        return resp;
    }

    getProductsForVersion(id: number): Observable<any> {
        var resp = this.authHttp.get(`${this.baseUrl}/api/version/${id}/products`);
        return resp;
    }

    saveVersionProducts(id: number, productIds: number[]) {
        var resp = this.authHttp.post(`${this.baseUrl}/api/version/${id}/products`, productIds);
        return resp;
    }

    uploadVersion(file: File): Observable<any> {
        let formData: FormData = new FormData();
        formData.append('uploadFile', file, file.name);
        let headers = new Headers();
        //headers.append('Content-Type', 'multipart/form-data');
        headers.append('Accept', 'application/json');
        let options = new RequestOptions({ headers: headers });
        var resp = this.authHttp.post(`${this.baseUrl}/api/version/upload`, formData, options);
        return resp;
    }
}



// WEBPACK FOOTER //
// ./Client/app/shared/software.service.ts